

export const nativeToken = {
  id: '0a14a304-f5cf-472d-ab30-2be348ae934f',
  address: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
  decimals: 18,
  iconUrl:
    'https://assets.coingecko.com/coins/images/32440/standard/polygon.png?1698233684',
  name: 'POL',
  symbol: 'POL',
}